import api from './api';
import { fetchPage } from './pagedParams';

// Moderation of the product reviews written on the website (SUPER_ADMIN).
const reviewService = {
  // params: page, size, sort, search, status (PENDING | PUBLISHED | REJECTED | all)
  getReviewsPage: (params) => fetchPage('/admin/reviews/paged', params),

  publishReview: async (id) => (await api.patch(`/admin/reviews/${id}/publish`)).data,

  rejectReview: async (id) => (await api.patch(`/admin/reviews/${id}/reject`)).data,

  unpublishReview: async (id) => (await api.patch(`/admin/reviews/${id}/unpublish`)).data,

  deleteReview: async (id) => {
    await api.delete(`/admin/reviews/${id}`);
  },
};

export default reviewService;
